export default __webpack_public_path__ + "static/media/avatar_brown_bear4.d1c5ce45.mp3";